export default "__VITE_ASSET__CHHGC0LK__"